"use strict";
// packages/types/src/api/admin.ts
Object.defineProperty(exports, "__esModule", { value: true });
